import React from 'react';

const SheetSvg = () => {
  return (
    <svg
      width="160"
      height="153"
      viewBox="0 0 160 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="sheet-svg"
    >
      <rect x="126" y="24.9548" width="6" height="106.806" fill="#E9E9EA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5938 27.0378C25.5938 26.2094 26.2653 25.5378 27.0937 25.5378H131.906C132.735 25.5378 133.406 26.2094 133.406 27.0378V131.655C133.406 132.483 132.735 133.155 131.906 133.155H27.0937C26.2653 133.155 25.5938 132.483 25.5938 131.655V27.0378Z"
        stroke="#BEBEC1"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.7188 47.0613H111.844"
        stroke="#D4D4D6"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1562 90.1082H111.844"
        stroke="#D4D4D6"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1562 68.5847H111.844"
        stroke="#D4D4D6"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1562 111.631H83.0937"
        stroke="#D4D4D6"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150.142 148.723C148.017 148.723 146.289 146.998 146.289 144.877L146.274 144.737H145.994V144.877C145.994 146.998 144.265 148.723 142.14 148.723L142 148.735V149.013H142.14C144.265 149.013 145.994 150.739 145.994 152.86L146.009 153H146.289V152.86C146.289 150.739 148.017 149.013 150.142 149.013L150.282 149.002V148.723H150.142Z"
        fill="#D4D4D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8479 4.33339C37.5386 4.33339 35.6608 2.45809 35.6608 0.151935L35.6445 0H35.3403V0.151935C35.3403 2.45809 33.4614 4.33339 31.1521 4.33339L31 4.34642V4.6492H31.1521C33.4614 4.6492 35.3403 6.52559 35.3403 8.83174L35.3566 8.98368H35.6608V8.83174C35.6608 6.52559 37.5386 4.6492 39.8479 4.6492L40 4.63726V4.33339H39.8479Z"
        fill="#D4D4D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.848 36.2753C157.539 36.2753 155.661 34.4 155.661 32.0938L155.645 31.9419H155.34V32.0938C155.34 34.4 153.461 36.2753 151.152 36.2753L151 36.2883V36.5911H151.152C153.461 36.5911 155.34 38.4675 155.34 40.7736L155.357 40.9256H155.661V40.7736C155.661 38.4675 157.539 36.5911 159.848 36.5911L160 36.5792V36.2753H159.848Z"
        fill="#D4D4D6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.86155 70.3706L6.55341 70.0281C6.36742 69.8214 6.06345 69.8214 5.87885 70.0281L2.42968 73.8756L1.07223 72.3668C0.925098 72.2033 0.684975 72.2033 0.539236 72.3668L0.110346 72.8435C-0.0367818 73.007 -0.0367818 73.2739 0.110346 73.4359L2.18262 75.7407C2.32975 75.9027 2.56987 75.9027 2.71561 75.7407L2.77529 75.6743C2.78085 75.6682 2.7864 75.6651 2.79056 75.6605L6.86155 71.1203C7.04615 70.9136 7.04615 70.5773 6.86155 70.3706Z"
        fill="#D4D4D6"
      />
    </svg>
  );
};

export default SheetSvg;
